import {
  Disconnectable,
  MutationObserverFactory,
  ObserverPort,
} from '../../../ports'

export class ObserverService implements ObserverPort {
  constructor(private mutationObserverFactory: MutationObserverFactory) {}

  registerAndObserve(
    elementToWatch: Node,
    callback: MutationCallback,
    observerConfig: MutationObserverInit = {
      childList: true,
      subtree: true,
      attributes: false,
    }
  ): Disconnectable {
    const mutationObserver = this.mutationObserverFactory.create(callback)
    mutationObserver.observe(elementToWatch, observerConfig)
    return { disconnect: () => mutationObserver.disconnect() }
  }
}
